var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M432 256c0 13.3-10.7 24-24 24H40c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h368c13.3 0 24 10.8 24 24z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }